// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2twgK","file":"styles_file__39cbI"};